import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './queryClient';
import { AuthProvider } from '@/modules/auth/contexts/AuthContext';

export function AppProviders({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <HelmetProvider>{children}</HelmetProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
